import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('sites', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
    'SYNCSITE'
]);

export const initialSitesState = {
    ...generateDefaultState('sites', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
        'SYNCSITE'
    ]),
};